import axios from '../../axios/axios.js';
import { TicketReplyType } from '@/util/UtilService.js';

const util = {
  restructureTicket(el) {
    let priority;
    if (el.priority_id === '1') priority = 'Nizak';
    if (el.priority_id === '2') priority = 'Srednji';
    if (el.priority_id === '3') priority = 'Visok';

    return {
      author: el.author,
      category_id: el.category_id,
      current_status: el.current_status,
      description: el.description,
      div_description: el.div_description,
      id: el.id,
      last_edit: el.last_edit,
      media: el.media,
      member_id: el.member_id,
      privacy: el.privacy,
      timestamp: el.timestamp,
      title: el.title,
      user_full_name: el.user_full_name,
      priority_id: priority,
      community_id: el.community_id,
      community_infrastructure: el.community_infrastructure,
      contact: el.contact,
      contractor: el.contractor,
      ticketDate: el.ticket_date,
      closed: el.closed,
      whoClosed: el.who_closed,
      log: el.log,
      isForwardedToContractor: el.isForwardedToContractor,
      projectId: el.projectId
    };
  }
};

export default {
  state: {
    basicInfo: null,
    ticketDetails: null,
    comments: null,
    userPicUrl: ''
  },
  mutations: {
    setTicket(state, payload) {
      state.ticketDetails = payload;
    },
    setBasicInfo(state, payload) {
      state.basicInfo = payload;
      localStorage.setItem('k-ti-m', JSON.stringify(payload));
    },
    setComments(state, payload) {
      state.comments = payload;
      // state.comments = payload.reverse();
    },
    setUserPicUrl(state, payload) {
      state.userPicUrl = payload;
    },
    updateTicket(state, payload) {
      state.ticketDetails.priority_id = payload.oldPriorityId;
      state.ticketDetails.privacy = payload.oldPrivacy;
      state.ticketDetails.current_status = payload.oldCurrentStatus;
    },
    clearTicketModule(state) {
      state.comments = null;
      state.ticketDetails = null;
      state.userPicUrl = '';
    },
    setState(state, payload) {
      state = payload;
    }
  },
  actions: {
    async getTicketDetails(context) {
      context.commit('loadingStarted', null, {
        root: true
      });
      const data = await axios.get(
        'tickets/' + context.state.basicInfo.ticketId,
        {
          params: {
            member_id: context.rootState.communities.activeCommunity.member_id
          }
        }
      );
      let t = util.restructureTicket(data.data.data);
      context.rootState.postTitle = data.data.data.title;
      context.commit('setTicket', t);

      context.dispatch('getTicketComments');
      // context.dispatch('getMemberProfilePicture');
      context.commit('loadingFinished', null, {
        root: true
      });
    },
    async getTicketComments(context) {
      try {
        const data = await axios.get(
          `tickets/${
            context.state.ticketDetails.id
          }/comment-replies-logs?offset=0`,
          {
            params: { count: 999 }
          }
        );
        for (const comment of data.data.data) {
          if (comment.type == TicketReplyType.COMMENT) {
            comment.data.medias = [];
            if (comment.data.media) {
              comment.data.medias = [comment.data.media];
            }
          }
        }

        console.log(data.data.data);
        context.commit('setComments', data.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    getMemberProfilePicture(context) {
      axios
        .post('member/get-member-info', {
          member_id: context.state.ticketDetails.member_id
        })
        .then(({ data }) => {
          context.commit('setUserPicUrl', data.media.link);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  getters: {},
  namespaced: true
};
